/* Credits
======================================== */
console.log('Leo Rosa: code by Carlos Mayo (https://carlosmayo.info/)');

/* Device detection
======================================== */
const isMobile = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
isMobile ? (
	document.body.classList.add('devices')
	// document.addEventListener('touchstart', () => {}, { passive: true })
) : (
	document.body.classList.add('desktop')
);

/* Loader
======================================== */
// setTimeout(() => document.getElementById('loader')?.classList.add('completed'), 500);

/* Observer: videos
======================================== */
let observerVideos;
const initObserverVideos = (target) => {
	observerVideos = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			const video = entry.target;
			if (entry.isIntersecting) {
				video.play()
					.then(() => video.classList.replace('lazy', 'lazyloaded'))
					.catch(() => {
						video.classList.replace('lazy', 'lazyloaded');
						observerVideos.unobserve(video);
					});
			} else {
				if (!video.paused && video.classList.contains('lazyloaded')) {
					video.pause();
				}
			}
		});
	});

	document.querySelectorAll(target).forEach(video => {
		observerVideos.observe(video);
	});
};

document.querySelector('video.lazy') && initObserverVideos('video.lazy');
